import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { gql } from 'graphql-tag';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import * as NotificationActions from '../../../core/notifications/notification.action';
import { Notification } from '../../../core/notifications/notification.model';
import { GET_MY_NOTIFICATIONS } from '../graphql/querries/notification.querries';
import { NEW_NOTIFICATION_SUBSCRIPTION } from '../graphql/subscription/notification.subscription';
import { parseJSON } from 'date-fns';
import { APPROVE_NOTIFICATION, REJECT_NOTIFICATION } from '../mutation/notification.mutation';


export interface NewNotificationResponse {
  newNotification: {
    id: string;
    title: string;
    message: string;
    notificationType: string;
    createdAt: string;
  };
}


@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  constructor(
    private apollo: Apollo,
    private store: Store
  ) {}

  startListening() {
    const loggedInUser:any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loggedInUser);
    const employeeId = Number(employee?.employeeData?.id);
    this.apollo.subscribe<{ newNotification: Notification }>({ 
      query: NEW_NOTIFICATION_SUBSCRIPTION, 
      variables:{
        recipientId: employeeId
      }
     }).subscribe({
      next: ({ data }) => {
        if (data?.newNotification) {
          const currentNotifications = this.notificationsSubject.getValue();
          this.notificationsSubject.next([data.newNotification, ...currentNotifications]);
          this.store.dispatch(NotificationActions.addNotification({ notification: data.newNotification }));
        }
      },
      error: (err) => console.error('Error in notification subscription:', err),
      complete: () => console.log('Notification subscription completed'),
    });
  }

  loadNotifications(): Observable<Notification[]> {
    console.log('inside loadNotifications');
    return this.apollo.use('communication')
    .query<{ getMyNotifications: Notification[] }>({
      query: GET_MY_NOTIFICATIONS,
      fetchPolicy:'network-only'
    }).pipe(
      tap((response) => {
        console.log('inside response');
        if (response?.data?.getMyNotifications) {
          this.store.dispatch(NotificationActions.loadNotifications({
            notifications: response.data.getMyNotifications
          }));
        }
      }),
      map((response) => response.data.getMyNotifications)
    );
  }

  getNotifications() {
    return this.notifications$;
  }


  approveNotification(notificationId: any): Observable<any> {
    return this.apollo.use('communication').mutate({
      mutation: APPROVE_NOTIFICATION,
      variables: { notificationId },
      fetchPolicy: 'no-cache',
    });
  }
  rejectNotification(notificationId: any): Observable<any> {
    return this.apollo.use('communication').mutate({
      mutation: REJECT_NOTIFICATION,
      variables: { notificationId },
      fetchPolicy: 'no-cache',
    });
  }

}
